import styled from 'styled-components';

export const LeadBoxAbertoContainer = styled.div`
    padding: 20px 0;

    @media (max-width: 768px) {
        display: none;
    }
`;

export const PhonesGrid = styled.div`
    display: grid;
    grid-auto-flow: ${(props) => (props.length > 4 ? 'row' : 'column')};
    grid-template-columns: 46% 46%;
    grid-template-rows: auto auto auto;
    justify-content: space-between;
`;

export const BoxForm = styled.form`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

export const BoxFeedback = styled.form`
    display: flex;
    align-items: center;
    flex-direction: column;
`;

export const BoxInfoContato = styled.div`
    display: flex;
    flex-direction: column;
    width: 65%;
`;

export const BoxInfoAnunciante = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    padding-bottom: 15px;
    justify-content: space-between;
`;

export const BoxTermosSubmit = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 30%;
`;
